/* eslint react/no-multi-comp: 0 */
import React from 'react';
import { Footer, Header } from 'marketing-components';
import Page from '../../lib/page';

const isLoggedIn = Page.isLoggedIn();

function parseMppLoggedOutContent(mppLoggedOutContent) {
  const currentLocationHref = Page.getCurrentLocationURL();
  const headerContent = mppLoggedOutContent;

  if (headerContent && Object.prototype.hasOwnProperty.call(headerContent, 'minimalHeader')) {
    // Adding return URI to sign button href to redirect to the users previous context.
    const { headerButtons } = headerContent.minimalHeader;
    headerButtons[0].href = `/signin/?returnUri=${currentLocationHref}`;

    return headerContent;
  }

  return headerContent;
}

// MPP Header
export const MppHeaderComponent = function () {
  if (!isLoggedIn && window.mppContent && window.mppContent.header) {
    const { contentLoggedOut, config, className } = window.mppContent.header.content;
    const props = { content: parseMppLoggedOutContent(contentLoggedOut), config, className };

    // Overriding header config to have the header menu as drop down for consistency
    // eslint-disable-next-line react/prop-types
    // props.config.version = 'v1';
    return <Header {...props} />;
  }
  return null;
};

// MPP Footer
export const MppFooterComponent = function () {
  if (!isLoggedIn && window.mppContent && window.mppContent.footer) {
    const props = window.mppContent.footer.content;
    return <Footer {...props} />;
  }
  return null;
};
